export function getYoutubeVideoId(urlOrId: string) {
  // If the passed string is a full Youtube URL, extract the video ID
  if (urlOrId.startsWith('https://www.youtube.com/watch?v=')) {
    return urlOrId.split('v=').pop()
  }

  // If the passed string is a shortened Youtube URL, extract the video ID
  if (urlOrId.startsWith('https://youtu.be/')) {
    return urlOrId.split('/').pop()
  }

  return urlOrId
}
